module.exports = "https://payments.pagoefectivo-pre.com/error-desktop.849899ca6ffe2edad539f61face2f043.png";